import {get} from "svelte/store";
import {cartItemsStore, cartTotalStore, clearCart} from "../cart/cart-store.js";
import {publishConfigStore, tenantKeyStore} from "../core/app-store.js";
import {
    clearOrderPlacementResults,
    deliveryStore,
    orderConfigStore,
    orderFormFieldsStore,
    setOrderPlacementResults
} from "./orders-store.js";
import {reachGoal} from "../core/ecommerce.js";
import {eventBus} from "../core/event-bus-store.js";
import {closeOrderScreen, openOrderPlacementResultScreen} from "../core/screens-manager.js";
import {getMenuId} from "../core/get-menu-id.js";

function getOrder (items, total, params, delivery) {

    const publishConfig = get(publishConfigStore);
    const tenantKey = get(tenantKeyStore);
    const menuId = getMenuId(publishConfig);

    return {
        tenantKey,
        menuId: menuId,
        orderDetails: {
            contact: {
                name: params.name,
                phone: params.phone,
                address: delivery.selectedDelivery ? params.address : undefined,
            },
            customFieldValuesMap: params.customFieldValuesMap,
            comment: params.comment,
            items: (items || []).map(x => {
                return {
                    menuKey: x.menuKey,
                    itemId: x.id,
                    name: x.name,
                    count: x.count,
                    price: x.price,
                    weight: x.weight,
                    mods: x.mods,
                    discount: x.discount,
                }
            }),
            onsite: delivery.selectedOnsite,
            pickupPoint: delivery.selectedPickup ? delivery.selectedPickupPoint?.address : undefined,
            totalPrice: total.sum,
            totalCount: total.count,
            currency: publishConfig.currency
        }
    };
}

export async function submitOrder (params) {

    params.name = (params.name || '').trim();
    params.phone = (params.phone || '').trim();
    params.address = (params.address || '').trim();
    params.comment = (params.comment || '').trim();

    const orderConfig = get(orderConfigStore);
    const orderFormFieldsConfig = get(orderFormFieldsStore);
    const delivery = get(deliveryStore);

    const nameIsEmpty = !delivery.selectedOnsite && orderFormFieldsConfig.requireNameField && params.name.length === 0;
    const phoneIsEmpty = !delivery.selectedOnsite && orderFormFieldsConfig.requirePhoneField && params.phone.length === 0;
    const phoneIsWrong = !delivery.selectedOnsite && orderFormFieldsConfig.requirePhoneField && !phoneIsEmpty && (params.phone.length < 5 || params.phone.length > 20);
    const commentIsEmpty = orderFormFieldsConfig.requireCommentField && params.comment.length === 0;

    const addressIsEmpty = delivery.selectedDelivery && orderFormFieldsConfig.requireAddressField && params.address.length === 0;
    const pickupPointIsEmpty = delivery.selectedPickup && orderConfig.pickupEnabled && !delivery.selectedPickupPoint;

    if (!nameIsEmpty && !phoneIsEmpty && !phoneIsWrong && !addressIsEmpty && !commentIsEmpty && !pickupPointIsEmpty) {

        const items = get(cartItemsStore);
        const total = get(cartTotalStore);
        const order = getOrder(items, total, params, delivery);
        const tenantKey = get(tenantKeyStore);

        order.apiKey = orderConfig.apiKey;
        const url = orderConfig.apiUrl;

        try {

            clearOrderPlacementResults();

            const makeRequest = async (attempt = 0) => {

                const res = await fetch(url + (url[url.length - 1] === '/' ? '' : '/') + tenantKey, {
                    method: 'POST',
                    body: JSON.stringify(order),
                    headers: {'content-type': 'application/json'}
                });

                switch (res.status) {

                    /// SUCCESS
                    case 200:
                    case 201:
                        const result = await res.json();
                        // console.log('Place order result', result);
                        if (result?.success) {
                            setOrderPlacementResults({orderNumber: result.orderNumber}, undefined);
                            reachGoal('ORDER_PLACED');
                            eventBus.set([{event: 'purchase', payload: {items, revenue: total?.sum, orderNumber: result.orderNumber}}]);
                        }
                        else {
                            setOrderPlacementResults({orderNumber: result.orderNumber}, {message: result.error?.message});
                            reachGoal('ORDER_FAILED');
                        }
                        closeOrderScreen();
                        clearCart();
                        break;

                    /// THROTTLING
                    case 429:
                    case 503:

                        /// Retry 4 times (0, 1, 2, 3)
                        if (attempt < 4) {

                            const delay = 2000 + 2000 * attempt * attempt; /// 2+4+10+20=36s
                            // const delay = 2000 + 2000 * attempt; /// 2+4+6+8=20s

                            console.log('delay', delay);
                            reachGoal(`ORDER_RETRY_${res.status}`);

                            return await new Promise(res => {
                                setTimeout(async () => {
                                    await makeRequest(attempt + 1);
                                    res();
                                }, delay);
                            });
                        }

                        setOrderPlacementResults({}, {status: res.status, message: `Ошибка размещения заказа (${res.status})`});
                        closeOrderScreen();
                        reachGoal(`ORDER_FAILED_${res.status}`);
                        break;

                    /// ERRORS
                    case 404:
                    case 500:
                    default:
                        setOrderPlacementResults({}, {status: res.status, message: `Ошибка размещения заказа (${res.status})`});
                        closeOrderScreen();
                        reachGoal('ORDER_FAILED');
                        break;
                }
            };

            await makeRequest(0);
        }
        catch (e) {
            setOrderPlacementResults({}, {status: 'Exception', message: e.message});
            closeOrderScreen();
            reachGoal('ORDER_EXCEPTION');
        }

        openOrderPlacementResultScreen();

        return {
            success: true
        };
    }
    else {
        return {
            success: false,
            error: {
                nameIsEmpty,
                phoneIsEmpty,
                phoneIsWrong,
                addressIsEmpty,
                commentIsEmpty,
                pickupPointIsEmpty
            }
        };
    }
}
